import React from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import {
  APP_DESCRIPTION,
  formatPageDescription,
  formatPageTitle,
} from "../../config/appConfig";

export type PageMetaProps = {
  title: string;
  description?: string;
};

const PageMeta = ({ title, description }: PageMetaProps) => {
  const documentTitle = title.includes("|") ? title : formatPageTitle(title);
  const metaDescription =
    description ?? (title.includes("|") ? APP_DESCRIPTION : formatPageDescription(title));

  return (
    <Helmet>
      <title>{documentTitle}</title>
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};

/** Document title + description from the visible page heading */
export function PageMetaFromHeading({
  pageTitle,
  description,
}: {
  pageTitle: string;
  description?: string;
}) {
  return (
    <PageMeta
      title={pageTitle}
      description={description ? formatPageDescription(pageTitle, description) : undefined}
    />
  );
}

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
